// Phase 6 — Track B T-B5. Copy entry point.
//
// Single English locale at v1; i18n is post-v2 per plan §3 D-B5.

import { authCopy } from './auth.js';
import { dashboardCopy } from './dashboard.js';
import { dailyDeckCopy } from './daily-deck.js';
import { alertsCopy } from './alerts.js';
import {
  paymentsCopy,
  STATEMENT_UPLOAD_MAX_BYTES,
  PAYMENT_CURRENCY_OPTIONS,
} from './payments.js';
import { datesCopy } from './dates.js';
import { errorsCopy, lookupErrorCopy } from './errors.js';
import { appCopy } from './app.js';
import { sharedCopy } from './shared.js';
import { settingsCopy } from './settings.js';
import { insightsCopy } from './insights.js';
import { notes as notesCopy } from './notes.js';
import { reading as readingCopy } from './reading.js';
import { subscriptions as subscriptionsCopy } from './subscriptions.js';

export {
  authCopy, dashboardCopy, dailyDeckCopy, alertsCopy, paymentsCopy,
  datesCopy, errorsCopy, appCopy, sharedCopy, settingsCopy, insightsCopy,
  notesCopy, readingCopy, subscriptionsCopy,
};
export { STATEMENT_UPLOAD_MAX_BYTES, PAYMENT_CURRENCY_OPTIONS };
export { lookupErrorCopy };
export type { ErrorCode } from './errors.js';

export const copy = {
  app: appCopy,
  auth: authCopy,
  dashboard: dashboardCopy,
  dailyDeck: dailyDeckCopy,
  alerts: alertsCopy,
  payments: paymentsCopy,
  dates: datesCopy,
  errors: errorsCopy,
  shared: sharedCopy,
  settings: settingsCopy,
  insights: insightsCopy,
  notes: notesCopy,
  reading: readingCopy,
  subscriptions: subscriptionsCopy,
} as const;
